import { useCallback, useState } from "react";
import { importPlayers } from "../../../api/index.js";
import ImportCSV from "./ImportCSV.js";
import { Box, CircularProgress, Typography } from "@mui/material";

const PlayersCSV = () => {
    const [loading, setLoading] = useState(false);
    const [importComplete, setImportComplete] = useState(false);
    const [response, setResponse] = useState([]);

    const handlePlayerImport = useCallback( async (rows) => {
        setLoading(true);

        // On filtre les lignes réellement vides
        const filteredRows = rows.filter(row => {
            // On garde la ligne si au moins une valeur non vide ET au moins une colonne obligatoire remplie
            const hasAtLeastOneValue = Object.values(row).some(
                val => val !== null && val !== undefined && String(val).trim() !== ''
            );

            return hasAtLeastOneValue;
        });

        if (filteredRows.length>0) {

         try {
        const { data } = await importPlayers(filteredRows);
        setResponse(s => s.concat([data.message]));
          } catch (error) {
              console.error(error);
              setResponse(error.message);
          } finally {
              setLoading(false);
          }
        }

        
    }, [])

    const handleImportComplete = () => {
      // Set importComplete after the entire import is complete
      setImportComplete(true);
      setLoading(false);
  };


    return <Box>
        <Typography variant="h2">Joueurs</Typography>
        <ImportCSV
          columns={[
            { id: 'lastname', label: 'last_name' },
            { id: 'discipline', label: 'discipline' },
            { id: 'provider', label: 'Groupe' },

            { id: 'firstname', label: 'first_name', optional : true },

            { id: 'number', label: 'Numero', optional : true },
            { id: 'birthday', label: 'birth_date', optional : true  },
            { id: 'nationality', label: 'Nationalité', optional : true },
            { id: 'size', label: 'height', optional : true  },
            { id: 'weight', label: 'weight', optional : true  },
            { id: 'positioning', label: 'position', optional : true  },


            { id: 'idTeam', label: 'team_id', optional : true },
            { id: 'idPlayer', label: 'player_id', optional : true },
            { id: 'thirdPartyTeam', label: 'thirdPartyTeam', optional : true },
            { id: 'thirdPartyPlayer', label: 'thirdPartyPlayer', optional : true },

            { id: 'teamName', label: 'team_name', optional : true },
            { id: 'teamStartDate', label: 'Date début' },
            { id: 'teamEndDate', label: 'Date fin' },
          ]}
          process={handlePlayerImport}
          onComplete={handleImportComplete}
        />

    {loading && <CircularProgress />}
    
    {importComplete && response.length && response.map((r, index) => <p key={index}>{r}</p>)}
  </Box>
}

export default PlayersCSV